import React from "react";
import _chunk from "lodash.chunk";
import Card, { CARD_MIN_WIDTH } from "./components/Card";
import { CARDS } from "./images/cards-data";
import useWindowDimensions from "./hooks/useWindowDimensions";

const HALF_BREAKPOINT = CARD_MIN_WIDTH * 4.5;
const SINGLE_BREAKPOINT = CARD_MIN_WIDTH * 2;

function App() {
  const { width } = useWindowDimensions();
  const cardsPerRow =
    width <= SINGLE_BREAKPOINT ? 1 : width <= HALF_BREAKPOINT ? 2 : 4;

  return (
    <div style={{ padding: 50 }}>
      {_chunk(CARDS, cardsPerRow).map((row, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
          }}
        >
          {row.map(([sideA, sideB]) => (
            <Card key={sideA} sideA={sideA} sideB={sideB} />
          ))}
        </div>
      ))}
    </div>
  );
}

export default App;
